function isCloudRasterOrShapefile(row) {
  if (row.facetClass === 'gov.sciencebase.catalog.item.facet.CloudRasterFacet' || row.facetClass === 'gov.sciencebase.catalog.item.facet.CloudShapefileFacet'){
    return true
  }
  return false
}

export {
  isCloudRasterOrShapefile
}
